import { ElementActionType } from '@agoda/analytics-data-acquisition';
import { useElementAnalytics } from '@agoda/analytics-data-acquisition-react';
import {
    PasskeyCreatedNotificationElementUniversalLoginFieldsV1,
    PasskeyCreatedNotificationElementUniversalLoginIdsV1,
    PasskeyTechnicalErrorNotificationElementUniversalLoginFieldsV1,
    PasskeyTechnicalErrorNotificationElementUniversalLoginIdsV1,
} from '@agoda/analytics-messages-definition-universal-login/elements.split';
import {
    PasskeyCreatedNotificationElementUniversalLoginManifestV1,
    PasskeyTechnicalErrorNotificationElementUniversalLoginManifestV1,
} from '@agoda/analytics-messages-definition-universal-login/manifest/elements';

export const useAnalytics = () => {
    const AnalyticsPasskeyTechnicalErrorNotificationProps = useElementAnalytics<
        PasskeyTechnicalErrorNotificationElementUniversalLoginIdsV1,
        PasskeyTechnicalErrorNotificationElementUniversalLoginFieldsV1
    >([ElementActionType.Seen], PasskeyTechnicalErrorNotificationElementUniversalLoginManifestV1.ids, []);

    const AnalyticsPasskeyCreatedNotificationProps = useElementAnalytics<
        PasskeyCreatedNotificationElementUniversalLoginIdsV1,
        PasskeyCreatedNotificationElementUniversalLoginFieldsV1
    >([ElementActionType.Seen], PasskeyCreatedNotificationElementUniversalLoginManifestV1.ids, []);

    return {
        AnalyticsPasskeyTechnicalErrorNotificationProps,
        AnalyticsPasskeyCreatedNotificationProps,
    };
};
